<template>
  <b-card class="default-card">
    <slot></slot>
  </b-card>
</template>

<script>
export default {
  name: "main-component"
}
</script>

<style scoped>

</style>